import React, { useState, useEffect } from 'react';
import { callApi, callPublicApi } from '../api';
import GaleriFormu from '../components/GaleriFormu';
import './YonetimSayfasi.css';

const GaleriYonetim = ({ kulup }) => {
    const [fotograflar, setFotograflar] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);
    const [isFormOpen, setIsFormOpen] = useState(false);

    useEffect(() => {
        fetchFotograflar();
    }, [kulup]);

    const fetchFotograflar = async () => {
        setIsLoading(true);
        setError(null);
        try {
            // Backend endpoint eksik olabilir ama pattern'i uyguluyoruz
            const query = kulup?.kulupID ? `?kulupID=${kulup.kulupID}` : '';
            const data = await callPublicApi(`/galeri${query}`);

            let parsedBody = [];
            if (data && data.body) {
                parsedBody = JSON.parse(data.body);
            } else if (Array.isArray(data)) {
                parsedBody = data;
            } else {
                parsedBody = [];
            }

            let items = Array.isArray(parsedBody) ? parsedBody : parsedBody.items || [];

            // KULÜP FILTRELEME
            if (kulup) {
                items = items.filter(item => {
                    if (kulup.kulupID === 'klugastro' || !kulup.kulupID) {
                        // Varsayılan kulüp: ID'siz veya eşleşen
                        return !item.kulupID || item.kulupID === 'klugastro';
                    }
                    return item.kulupID === kulup.kulupID;
                });
            }

            setFotograflar(items);
        } catch (err) {
            console.error("Galeri yükleme hatası:", err);
            // setError("Fotoğraflar yüklenemedi."); // Sessizce geçiştir (backend yoksa hata vermesin)
        } finally {
            setIsLoading(false);
        }
    };

    const handleDelete = async (id) => {
        if (!window.confirm("Bu fotoğrafı silmek istediğinizden emin misiniz?")) return;
        setIsLoading(true);
        try {
            await callApi(`/galeri?id=${id}`, 'DELETE');
            fetchFotograflar();
        } catch (err) {
            setError(err.message || "Silme işlemi başarısız oldu.");
            setIsLoading(false);
        }
    };

    const handleFormSave = () => {
        setIsFormOpen(false);
        fetchFotograflar();
    };

    if (isLoading && fotograflar.length === 0) return <div className="loading-state">Fotoğraflar Yükleniyor...</div>;
    // if (error) return <div className="error-state">Hata: {error}</div>;

    return (
        <div className="yonetim-sayfasi">
            <h2>Galeri Yönetimi {kulup ? `(${kulup.ad})` : ''}</h2>
            <button className="primary-button" onClick={() => setIsFormOpen(true)}>
                Yeni Fotoğraf Ekle
            </button>

            {isFormOpen && (
                <div className="modal-overlay">
                    <div className="modal-content">
                        <GaleriFormu
                            kulup={kulup}
                            onSave={handleFormSave}
                            onCancel={() => setIsFormOpen(false)}
                        />
                    </div>
                </div>
            )}

            <div className="gallery-grid-admin">
                {fotograflar.length > 0 ? (
                    fotograflar.map((foto) => (
                        <div key={foto.id || foto.galeriID} className="gallery-item-admin">
                            <img src={foto.resimURL} alt={foto.aciklama || 'Galeri Fotoğrafı'} />
                            <div className="gallery-item-actions">
                                <button onClick={() => handleDelete(foto.id || foto.galeriID)} className="danger-button">Sil</button>
                            </div>
                        </div>
                    ))
                ) : (
                    <p className="no-data">Henüz eklenmiş fotoğraf bulunmamaktadır.</p>
                )}
            </div>

            <style>{`
                .gallery-grid-admin {
                    display: grid;
                    grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
                    gap: 20px;
                    margin-top: 20px;
                }
                .gallery-item-admin {
                    border: 1px solid #ddd;
                    border-radius: 8px;
                    overflow: hidden;
                    position: relative;
                }
                .gallery-item-admin img {
                    width: 100%;
                    height: 200px;
                    object-fit: cover;
                }
                .gallery-item-actions {
                    padding: 10px;
                    text-align: center;
                    background: #f9f9f9;
                }
            `}</style>
        </div>
    );
};

export default GaleriYonetim;
